import { render, staticRenderFns } from "./change-label.vue?vue&type=template&id=5748bb82&scoped=true"
import script from "./change-label.vue?vue&type=script&lang=js"
export * from "./change-label.vue?vue&type=script&lang=js"
import style0 from "./change-label.vue?vue&type=style&index=0&id=5748bb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748bb82",
  null
  
)

export default component.exports